import { FeatureDefinition } from '../entities';

export const redirectToAsknebulaFeatureName = 'appnebula-redirect-to-asknebula';

export const redirectToAsknebulaFeatureConfig: FeatureDefinition = {
  defaultValue: false,
};
